// @flow
import React from 'react';
import styled from 'styled-components';
import { Button } from '@finect/tabular-core/Button';
import { QuestionSuggestion } from '@finect/tabular-components/QuestionSuggestion';
import { Flex } from '@finect/tabular-core/Flex';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Search } from '@finect/tabular-icons/search';
import { keyMap } from '@finect/front-utils/keyMap';

export const NewQuestionBlock = styled.div`
  margin-bottom: 48px;

  ${maxMediaQueries.phablet`
    margin-bottom: 30px;
  `};
`;

// TODO: Change line-height for padding
const Input = styled.input`
  flex: 1;
  margin-right: 9px;
  ${getFont(0)};
  font-weight: 600;
  line-height: 30px;

  ::placeholder {
    padding-left: 2px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${({ theme }) => theme.colors.fontLL};
  }

  /* stylelint-disable */
  :-ms-input-placeholder {
    display: inline-block;
    line-height: normal;
  }
  /* stylelint-enable */
`;

const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

/* eslint-disable */
const NewQuestionInput = styled.div`
  position: relative;
  padding: 9px;

  ${/* sc-sel */ Input} {
    ${maxMediaQueries.phone`
      padding-right: ${({ isEmpty }) => (isEmpty ? 0 : '96px')};
    `};
  }

  ${/* sc-sel */ Button} {
    opacity: ${({ isEmpty }) => (isEmpty ? 0 : 1)};
    width: auto;
    cursor: ${({ isEmpty }) => (isEmpty ? 'default' : 'pointer')};
    transition: opacity 0.15s ease;

    ${maxMediaQueries.phone`
      position: absolute;
      top: 9px;
      right: 36px;
    `};

    &:hover {
      opacity: ${({ isEmpty }) => (isEmpty ? 0 : 0.9)};
    }
  }
`;
/* eslint-enable */

type Props = {
  placeholder: string,
  tagId?: number,
  handleReturn: Function
};

type State = {
  isEmpty: boolean,
  searchTerm: string
};

export class NewQuestion extends React.Component<Props, State> {
  input: any;
  data: Object = { callbacks: {} };

  state = {
    isEmpty: true,
    searchTerm: ''
  };

  newQuestion = (event?: SyntheticEvent<HTMLElement>) => {
    if (event && this.state.isEmpty) return this.input.focus();
    this.props.handleReturn(this.input.value);
  };

  handleKeyDown = (event: SyntheticKeyboardEvent<HTMLElement>) => {
    if (event.keyCode === keyMap.RETURN) {
      event.preventDefault();
      this.newQuestion();
    }
    const { onEscape } = this.data.callbacks;
    if (event.keyCode === keyMap.ESCAPE && onEscape) {
      onEscape();
    }
  };

  handleChange = () => {
    const newState = {};
    newState.searchTerm = this.input.value;

    if (this.input.value.trim() !== '') {
      if (this.state.isEmpty) newState.isEmpty = false;
    } else if (!this.state.isEmpty) newState.isEmpty = true;

    this.setState(newState);
  };

  render() {
    const { placeholder, tagId } = this.props;
    const { isEmpty, searchTerm } = this.state;

    return (
      <NewQuestionInput isEmpty={isEmpty}>
        <Flex align="center">
          <Input
            ref={el => (this.input = el)}
            type="text"
            placeholder={placeholder}
            onKeyDown={this.handleKeyDown}
            onChange={this.handleChange}
          />
          <Button secondary variant="small" onClick={this.newQuestion}>
            Pregunta
          </Button>
          <SearchContainer>
            <Search />
          </SearchContainer>
        </Flex>
        <QuestionSuggestion decoratedText={searchTerm} tagId={tagId} editor={this.data} />
      </NewQuestionInput>
    );
  }
}
